import auth from '@/middleware/Auth'
import admin from '@/middleware/Admin'
import owner from '@/middleware/Owner'
import employee from '@/middleware/Employee'

export default {
  path: '/member',
  icon: 'mdi-tshirt-crew',
  title: 'Member',
  component: () => import('@/views/members/index.vue'),
  children: [
    {
      path: '',
      name: 'MemberList',
      title: 'Member List',
      icon: 'mdi-format-list-bulleted',
      component: () => import('@/views/members/page/MemberList.vue'),
      meta: {
        middleware: {
          auth,
          admin,
          owner
        }
      }
    },
    {
      path: 'add-spending',
      name: 'MemberAddSpending',
      title: 'Member Spent',
      icon: 'mdi-account-star',
      component: () => import('@/views/members/page/MemberAddSpending.vue'),
      meta: {
        middleware: {
          auth,
          admin,
          owner,
          employee
        }
      }
    },
    {
      path: ':id',
      name: 'MemberDetail',
      hide: true,
      component: () => import('@/views/members/page/MemberDetail.vue'),
      meta: {
        middleware: {
          auth,
          admin,
          owner
        }
      }
    },
    {
      path: ':id/edit',
      name: 'MemberEdit',
      hide: true,
      component: () => import('@/views/members/page/MemberEdit.vue'),
      meta: {
        middleware: {
          auth,
          admin,
          owner
        }
      }
    }
  ]
}
